// ============================================================
// Datei: src/pages/ressorts/chai/Chai.jsx
// 🔥 FIX:
// - reloadVolunteers abgesichert
// ============================================================

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "../../../styles/global.css";
import "../../../styles/ressortTabs.css";
import "../../../styles/ccMailCard.css";

import useVolunteers from "../../../components/fetch/useVolunteers";
import useShifts from "../../../components/fetch/useShifts";
import Api from "../../../Api";

import ChaiDesktop from "./ChaiDesktop";
import ChaiMobile from "./ChaiMobile";
import useMediaQuery from "../../../hooks/useMediaQuery";

const Chai = () => {

	const isMobile = useMediaQuery("(max-width: 768px)");
	const navigate = useNavigate();

	const volunteersHook = useVolunteers("Chai");

	const volunteers = volunteersHook[0];
	const setVolunteers = volunteersHook[1];

	// 🔥 FIX: fallback
	const reloadVolunteers = volunteersHook[2] || (() => {
		console.warn("reloadVolunteers nicht vorhanden");
	});

	const [shifts] = useShifts("Chai");

	const [selectedVolunteer, setSelectedVolunteer] = useState(null);
	const [guests, setGuests] = useState([]);
	const [activeTab, setActiveTab] = useState("overview");

	useEffect(() => {
		const role = localStorage.getItem("role");
		const dept = localStorage.getItem("department");

		if (role !== "OK" || dept?.toLowerCase() !== "chai") {
			alert("Zugriff verweigert!");
			navigate("/home");
			return;
		}

		loadGuests();
	}, [navigate]);

	const loadGuests = () => {
		Api.get("/guests").then(res => setGuests(res.data));
	};

	const downloadCcEmails = async () => {
		try {
			const res = await Api.get("/cc-emails", {
				responseType: "blob"
			});

			if (!res.data || res.data.size === 0) {
				throw new Error("Leere Datei");
			}

			const blob = new Blob([res.data], { type: "text/plain" });
			const url = window.URL.createObjectURL(blob);

			const a = document.createElement("a");
			a.href = url;
			a.download = "helferfest_cc_liste.txt";
			document.body.appendChild(a);
			a.click();
			a.remove();

			window.URL.revokeObjectURL(url);

		} catch (err) {
			console.error("CC-Download Fehler:", err);
			alert("Download fehlgeschlagen");
		}
	};

	const layoutProps = {
		volunteers,
		setVolunteers,
		reloadVolunteers, // 🔥 wichtig
		shifts,
		guests,
		selectedVolunteer,
		setSelectedVolunteer,
		activeTab,
		setActiveTab,
		reloadGuests: loadGuests,
		downloadCcEmails
	};

	return (
		<div
			className="chai-page bg-reveal"
			data-bg={`${process.env.PUBLIC_URL}/backgrounds/background_chai.png`}
		>
			<h2 className="chai-heading">Chai</h2>

			{isMobile
				? <ChaiMobile {...layoutProps} />
				: <ChaiDesktop {...layoutProps} />
			}
		</div>
	);
};

export default Chai;